var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-automation-list" },
    [
      _c("h3", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("automation.automations"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("a-input-search", {
                  staticClass: "row search-input",
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: _vm.$t("message.startFilter") },
                  on: {
                    input: function ($event) {
                      return _vm.onSearch($event.target.value)
                    },
                  },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
                _vm._v(" "),
                _c("CommonFilterTool", {
                  attrs: {
                    "keep-state-on-query-params": false,
                    "filter-meta": _vm.filterMetas,
                    "label-formatter": _vm.filterLabelFormatter,
                  },
                  on: { addFilter: _vm.addFilter },
                  model: {
                    value: _vm.breakdownFilter,
                    callback: function ($$v) {
                      _vm.breakdownFilter = $$v
                    },
                    expression: "breakdownFilter",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", disabled: _vm.loading },
                    on: { click: _vm.createEmptyTimerAutomation },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("automation.createTimerAutomation")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "" },
                    on: { click: _vm.showEventAutomationModal },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("automation.createEventBasedAutomation")
                        ) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "" },
                    on: { click: _vm.showWebhookAutomationModal },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("automation.createWebhookAutomation")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.checkboxOption.selectedRowKeys.length > 0
            ? _c(
                "SupsisButton",
                {
                  attrs: { danger: "" },
                  on: { click: _vm.deleteMultiAutomations },
                },
                [
                  _vm._v(
                    "\n            Delete " +
                      _vm._s(_vm.checkboxOption.selectedRowKeys.length) +
                      " selected\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.items,
              "top-pagination": !_vm.checkboxOption.selectedRowKeys.length,
              "empty-data-bordered": "",
              "bottom-pagination": !_vm.checkboxOption.selectedRowKeys.length,
              "pagination-cursor": _vm.pagination,
              options: {
                checkboxOption: _vm.checkboxOption,
                rowStyleOption: _vm.rowStyleOption,
                clipboardOption: _vm.clipboardOption,
                fixedHeader: true,
                id: "automation-table",
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.eventAutomationModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.createAnEventAutomation"),
                "show-title": "",
                "show-footer": false,
                "class-name": "create-event-automation-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.eventAutomationModalVisible = false
                },
              },
            },
            [
              _c("EventSelector", {
                on: { save: _vm.createEmptyEventAutomation },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.webhookAutomationFormModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.chatWebhookAutomation"),
                "show-title": "",
                "show-footer": false,
                "class-name": "event-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.webhookAutomationFormModalVisible = false
                },
              },
            },
            [
              _c("WebhookAutomationForm", {
                on: { save: _vm.createWebhookAutomation },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tableSelectionModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Tablo Seçimi",
                "show-title": "",
                "show-footer": false,
                "class-name": "table-selection-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.tableSelectionModalVisible = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "table-selection-form" },
                [
                  _vm.$event
                    ? _c(
                        "div",
                        { staticClass: "event-description" },
                        [
                          _vm.$event.event === "table.record_created"
                            ? [
                                _vm._v(
                                  "\n                    Automasyonu hangi tabloya kayıt eklendiğinde çalıştırmak istiyorsunuz? Lütfen seçim yapınız.\n                "
                                ),
                              ]
                            : _vm.$event.event === "table.record_updated"
                            ? [
                                _vm._v(
                                  "\n                    Automasyonu hangi tablodaki bir kayıt güncellendiğinde çalıştırmak istiyorsunuz? Lütfen seçim\n                    yapınız.\n                "
                                ),
                              ]
                            : _vm.$event.event === "table.record_deleted"
                            ? [
                                _vm._v(
                                  "\n                    Automasyonu hangi tablodan bir kayıt silindiğinde çalıştırmak istiyorsunuz? Lütfen seçim\n                    yapınız.\n                "
                                ),
                              ]
                            : _vm.$event.event ===
                              "table.record_automation_button_clicked"
                            ? [
                                _vm._v(
                                  "\n                    Automasyonu hangi tablodaki bir kayıt üzerindeki otomasyon düğmesine tıklandığında çalıştırmak\n                    istiyorsunuz? Lütfen seçim yapınız.\n                "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("CustomPicker", {
                    attrs: {
                      items: _vm.tables,
                      idKey: "_id",
                      labelKey: "name",
                      title: "Tablo Seçin",
                      icon: "table_chart",
                    },
                    model: {
                      value: _vm.selectedTableId,
                      callback: function ($$v) {
                        _vm.selectedTableId = $$v
                      },
                      expression: "selectedTableId",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "" },
                      on: { click: _vm.createEventAutomationWithTable },
                    },
                    [_vm._v("Oluştur")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }